import { AnskaffningsformFilter } from "./AnskaffningsformFilter";
import { BarighetsFilter } from "./BarighetsFilter";
import { GrotFilter } from "./GrotFilter";
import { IAnskaffningsformFilter } from "./IAnskaffningsformFilter";
import { IAnsvarigAvverkningsledareFilter } from "./IAnsvarigAvverkningsledareFilter";
import { IGetArbetsorderRequest } from "./IGetArbetsorderRequest";
import { IGrotFilter } from "./IGrotFilter";
import { IHandelssortimentFilter } from "./IHandelssortimentFilter";
import { IMaskinLagBase } from "./IMaskinLagBase";
import { IProduktionsmalsOmrade } from "./IProduktionsmalsOmrade";
import { IRestriktionStatusFilter } from "./IRestriktionStatusFilter";
import { ISkogligdataFilter } from "./ISkogligdataFilter";
import { IStatusFilter } from "./IStatusFilter";
import { IVirkeskopfilter } from "./IVirkeskopFilter";
import { IVirkesorderFilter } from "./IVirkesorderFilter";
import { PlaneringsstatusFilter } from "./PlaneringsstatusFilter";
import { ProduktionsstatusFilter } from "./ProduktionsstatusFilter";
import { RestriktionStatusFilter } from "./RestriktionStatusFilter";
import { SkogligdataFilter } from "./SkogligdataFilter";
import { StatusFilter } from "./StatusFilter";
import { TradslagsFilter } from "./TradslagsFilter";
import { Virkeskopfilter } from "./VirkeskopFilter";
import { VirkesorderFilter } from "./VirkesorderFilter";

export class GetArbetsorderRequest implements IGetArbetsorderRequest {

    omraden: IProduktionsmalsOmrade[];
    avverkningsgrupper: string[];
    status: IStatusFilter;
    periodDateFrom: string;
    periodDateTom: string;
    periodsattPeriod: string;
    faltplaneratDatum: string;
    skordningSkotning: string;
    arbetsorderCreatedDateFrom: string;
    arbetsorderCreatedDateTom: string;
    ejTidsatta: boolean;
    handelssortiment: IHandelssortimentFilter[];
    skogligdata: ISkogligdataFilter;
    anskaffningsform: IAnskaffningsformFilter;
    virkeskop: IVirkeskopfilter;
    beteckning: string;
    virkeskopare: number;
    kontraktsnummer: number;
    maskinlag: IMaskinLagBase[];
    restriktioner: string[];
    restriktionStatus: IRestriktionStatusFilter;
    grot: IGrotFilter;
    produktionGodkand: boolean;
    virkesorder: IVirkesorderFilter;
    virkesorderSkapadFrom: string;
    virkesorderSkapadTom: string;
    virkesorderGiltigFrom: string;
    virkesorderGiltigTom: string;
    virkesorderAndradFrom: string;
    virkesorderAndradTom: string;
    avverkningsAnsvarig?: IAnsvarigAvverkningsledareFilter;
    barighet: number[];
    ytstruktur: number[];
    lutning: number[];

    constructor() {
        this.applyDefaultValues();
    }

    applyDefaultValues() {
        this.periodDateFrom = null;
        this.periodDateTom = null;
        this.periodsattPeriod = null;
        this.faltplaneratDatum = null;
        this.skordningSkotning = "SKOTNING";
        this.arbetsorderCreatedDateFrom = null;
        this.arbetsorderCreatedDateTom = null;
        this.ejTidsatta = false;
        this.beteckning = "";
        this.omraden = [];
        this.avverkningsgrupper = [];
        this.status = new StatusFilter();
        this.status.produktionsstatus = new ProduktionsstatusFilter();
        this.status.planeringsstatus = new PlaneringsstatusFilter();
        this.status.virkesorderstatus = [];
        this.handelssortiment = [];
        this.virkeskop = new Virkeskopfilter();
        this.virkeskop.affarsformer = [];
        this.virkeskop.virkeskopare = [];
        this.skogligdata = new SkogligdataFilter();
        this.skogligdata.searchOnArbetsorder = true;
        this.skogligdata.tillganglighet = new BarighetsFilter();
        this.skogligdata.produktgrupper = [];
        this.skogligdata.produktgrupperBool = "and";
        this.skogligdata.tradslag = new TradslagsFilter();
        this.anskaffningsform = new AnskaffningsformFilter();
        this.maskinlag = [];
        this.restriktioner = [];
        this.restriktionStatus = new RestriktionStatusFilter();
        this.grot = new GrotFilter();
        this.virkesorder = new VirkesorderFilter();
        this.produktionGodkand = false;
        this.virkesorderSkapadFrom = null;
        this.virkesorderSkapadTom = null;
        this.virkesorderGiltigFrom = null;
        this.virkesorderGiltigTom = null;
        this.virkesorderAndradFrom = null;
        this.virkesorderAndradTom = null;
        this.avverkningsAnsvarig = undefined;
        this.barighet = [];
        this.ytstruktur = [];
        this.lutning = [];
    }

    resetAllFilters(): void {
        this.applyDefaultValues();
    }
}
